import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f5c60cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msg-time" }
const _hoisted_2 = {
  key: 0,
  class: "date"
}
const _hoisted_3 = { class: "msg-time" }
const _hoisted_4 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-spinner icon" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" No messages here yet... ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-arrow-bottom" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  class: "msg-input input-disabled"
}
const _hoisted_11 = {
  key: 1,
  ref: "dropZoneRef",
  class: "d-dialog-wrapper"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Drop some files here ")
const _hoisted_13 = {
  key: 0,
  class: "date"
}
const _hoisted_14 = { class: "msg-time" }
const _hoisted_15 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-spinner icon" })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" No messages here yet... ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-arrow-bottom" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 4,
  class: "msg-input input-disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_mock_item = _resolveComponent("message-mock-item")!
  const _component_message_item = _resolveComponent("message-item")!
  const _component_app_skeleton_message_media = _resolveComponent("app-skeleton-message-media")!
  const _component_app_no_message = _resolveComponent("app-no-message")!
  const _component_app_message_input = _resolveComponent("app-message-input")!
  const _component_AppSkeletonDialog = _resolveComponent("AppSkeletonDialog")!
  const _component_app_drop_zone = _resolveComponent("app-drop-zone")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.mainStore.isMobile)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["dialog", [_ctx.messagesStore.currentConversation?.contactStatus !== _ctx.CONTACT_STATUS.CONTACT ? 'h-125' : '']])
        }, [
          (_ctx.messagesStore.currentConversation?.messages?.length && _ctx.messagesStore.currentConversation?.allowedToWrite)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 0,
                class: "scroll dialog__list",
                ref: "scrollItem",
                onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
                onTouchmove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.blurInput && _ctx.blurInput(...args))),
                onWheel: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reverseScroll && _ctx.reverseScroll(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mockMessages, (msg) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "dialog__item",
                    key: msg.uuid
                  }, [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_message_mock_item, {
                        onResend: _ctx.resendMessage,
                        msg: msg
                      }, null, 8, ["onResend", "msg"])
                    ])
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "dialog__item",
                    key: msg.id
                  }, [
                    (msg.showDate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(msg.created)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_message_item, {
                        msg: msg,
                        "is-group": ""
                      }, null, 8, ["msg"])
                    ])
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletons, (n) => {
                  return (_openBlock(), _createBlock(_component_app_skeleton_message_media, {
                    key: n,
                    my: "",
                    "is-photo": "",
                    onMounted: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToBottom(true)))
                  }))
                }), 128)),
                (_ctx.messagesLoading)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_4, _hoisted_6))
                  : _createCommentVNode("", true)
              ], 544))
            : (!_ctx.dataLoading)
              ? (_openBlock(), _createBlock(_component_app_no_message, {
                  key: 1,
                  icon: 'icon-no-message',
                  class: "scroll scroll--no-messages"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "slide-down" }, {
            default: _withCtx(() => [
              (_ctx.showGoBottom)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollToBottom(true))),
                    class: "dialog__go-bottom"
                  }, _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.messagesStore.currentConversation?.allowedToWrite)
            ? (_openBlock(), _createBlock(_component_app_message_input, {
                key: 2,
                class: "msg-input",
                onSend: _ctx.sendMessage,
                onStartUpload: _ctx.onStartUpload,
                onOnFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scrollToBottom(true))),
                "is-group": "",
                "no-search": ""
              }, null, 8, ["onSend", "onStartUpload"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$localize('messages.not.connected.to.group')), 1)
              ])),
          (_ctx.dataLoading)
            ? (_openBlock(), _createBlock(_component_AppSkeletonDialog, {
                key: 4,
                title: _ctx.messagesStore.currentConversation?.info.name,
                "hide-skeletons": _ctx.hideSkeletons
              }, null, 8, ["title", "hide-skeletons"]))
            : _createCommentVNode("", true)
        ], 2)), [
          [
            _directive_loading,
            _ctx.fullscreenLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      : _createCommentVNode("", true),
    (!_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.isOverDropZone)
            ? (_openBlock(), _createBlock(_component_app_drop_zone, {
                key: 0,
                "indents-height": 105,
                class: "drop-zone-box"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["d-dialog", [_ctx.messagesStore.currentConversation?.contactStatus !== _ctx.CONTACT_STATUS.CONTACT ? 'h-125' : '']])
          }, [
            (_ctx.messagesStore.currentConversation?.messages?.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "d-scroll d-scroll--reverse",
                  ref: "scrollItem",
                  onScroll: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
                  onWheel: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.reverseScroll && _ctx.reverseScroll(...args)))
                }, [
                  _createVNode(_TransitionGroup, {
                    class: "d-dialog__list",
                    name: "fade",
                    mode: "out-in",
                    tag: "ul"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "d-dialog__item",
                          key: msg.id
                        }, [
                          (msg.showDate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(msg.created)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_message_item, {
                              msg: msg,
                              "is-group": ""
                            }, null, 8, ["msg"])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  (_ctx.messagesLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletons, (n) => {
                    return (_openBlock(), _createBlock(_component_app_skeleton_message_media, {
                      my: "",
                      key: n
                    }))
                  }), 128))
                ], 544))
              : (!_ctx.dataLoading)
                ? (_openBlock(), _createBlock(_component_app_no_message, {
                    key: 1,
                    icon: 'icon-no-message',
                    class: "scroll scroll--no-messages"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
            (_ctx.dataLoading)
              ? (_openBlock(), _createBlock(_component_AppSkeletonDialog, {
                  key: 2,
                  title: _ctx.messagesStore.currentConversation?.info.name,
                  class: "skeleton-loader"
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(_Transition, { name: "slide-down" }, {
              default: _withCtx(() => [
                (_ctx.showGoBottom)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.scrollToBottom(true))),
                      class: "dialog__go-bottom"
                    }, _hoisted_20))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.messagesStore.currentConversation?.allowedToWrite || _ctx.dataLoading)
              ? (_openBlock(), _createBlock(_component_app_message_input, {
                  key: 3,
                  class: "d-msg-input",
                  onSend: _ctx.sendMessage,
                  onStartUpload: _ctx.onStartUpload,
                  onOnFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.scrollToBottom(true))),
                  "is-group": "",
                  "no-search": ""
                }, null, 8, ["onSend", "onStartUpload"]))
              : _createCommentVNode("", true),
            (!_ctx.messagesStore.currentConversation?.allowedToWrite && !_ctx.dataLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$localize('messages.not.connected.to.group')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}